var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneLemon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52645 8.31032C10.8507 11.6336 11.6048 7.78893 13.7214 9.90401C15.7619 11.944 16.9347 12.3527 14.3494 14.9373C14.0255 15.1975 11.968 18.3285 4.73717 11.0997C-2.49457 3.87 0.634654 1.81037 0.894975 1.48662C3.48656 -1.10513 3.88822 0.0744857 5.92874 2.11444C8.0453 4.23041 4.20221 4.98701 7.52645 8.31032Z",
    fill: "#F4CE14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLemon);
export default __webpack_public_path__ + "static/media/phone_lemon.0bb3b576544eb3bd454168e5329b1ede.svg";
export { ForwardRef as ReactComponent };